import { render, staticRenderFns } from "./school-management.vue?vue&type=template&id=c0a60ee6&scoped=true&"
import script from "./school-management.vue?vue&type=script&lang=js&"
export * from "./school-management.vue?vue&type=script&lang=js&"
import style0 from "./school-management.vue?vue&type=style&index=0&id=c0a60ee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a60ee6",
  null
  
)

export default component.exports